import { render, staticRenderFns } from "./CustomerConfigEdit.vue?vue&type=template&id=4327d15b&"
import script from "./CustomerConfigEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerConfigEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerConfigEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports